// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__35Wj_","notes":"Notes_notes__Z_aFr"};